import axios from '../api/axios';

export const login = (credentials) => axios.post('/api-token-auth/', credentials);

export const fetchUserData = () => axios.get('/users/me/');